import { mapState, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import FileSelectorButton from '@/components/Ui/FileSelectorButton'
import MultipleFileInput from '@/components/Ui/MultipleFileInput'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Jsonb from '@/utils/Jsonb'
import Validator from '@/utils/Validator'
import Item from './Item'
import ImageResize from '@/utils/ImageResize'

export default {
  name: 'ServiceFunctionDetailFamilyInfo',
  components: {
    Loading,
    FileSelectorButton,
    MultipleFileInput,
    Item
  },
  data () {
    return {
      loading: true,
      processing: false,
      modelName: '',
      linkedSmartPhoneCount: 0,
      // リンク集カテゴリ
      deleteTargetLinkCategory: null,
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceFunctionDetail.categoryName,
      functionName: state => state.serviceFunctionDetail.functionName,

      // form
      serviceUuid: state => state.serviceFunctionDetail.serviceId,
      communityUuid: state => state.serviceFunctionDetail.communityId,
      serviceFunctionUuid: state => state.serviceFunctionDetail.targetId,
      values: state => state.serviceFunctionDetail.values,
      deliveryType: state => state.serviceFunctionDetail.deliveryType,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept,

      // 検索
      filters: state => state.serviceFunctionDetail.filters,

      // リンク集カテゴリ
      linkCategoryList: state => state.serviceLinkCategory.values,
      originalCategoryList:state=>state.serviceLinkCategory.originalValues,
      linkCategoryName: state => state.serviceLinkCategory.categoryName
    }),

    // input
    inpAreaCode: {
      get () {
        return this.values.inpAreaCode
      },
      set (value) {
        this.setInputValue({
          key: 'inpAreaCode',
          value: value
        })
      }
    },
    inpMaxLinkedSPCount: {
      get () {
        return this.values.inpMaxLinkedSPCount
      },
      set (value) {
        this.setInputValue({
          key: 'inpMaxLinkedSPCount',
          value: value
        })
      }
    },
    inpServiceName: {
      get () {
        return this.values.inpServiceName
      },
      set (value) {
        this.setInputValue({
          key: 'inpServiceName',
          value: value
        })
      }
    },
    inpServiceProtocol: {
      get () {
        return this.values.inpServiceProtocol
      },
      set (value) {
        this.setInputValue({
          key: 'inpServiceProtocol',
          value: value
        })
      }
    },
    inpLoadingAnimationFile: {
      get () {
        return this.values.inpLoadingAnimationFile
      },
      set (value) {
        this.setInputValue({
          key: 'inpLoadingAnimationFile',
          value: value
        })
      }
    },
    inpMainVisualFile() {
      return this.values.inpMainVisualFile
    },
    inpSubVisualFile() {
      return this.values.inpSubVisualFile
    },
    isAddCategoryBtnDisabled() {
      if (this.linkCategoryList.length !== this.originalCategoryList.length)
        return true;
      else
        return this.linkCategoryList.some(
          (item, index) =>
            item.categoryName !==
            this.originalCategoryList[index].categoryName
        );
    },
    inpContact: {
      get () {
        return this.values.inpContact
      },
      set (value) {
        this.setInputValue({
          key: 'inpContact',
          value: value
        })
      }
    },
    inpDepartmentInCharge: {
      get () {
        return this.values.inpDepartmentInCharge
      },
      set (value) {
        this.setInputValue({
          key: 'inpDepartmentInCharge',
          value: value
        })
      }
    },
    inpCopyRight: {
      get () {
        return this.values.inpCopyRight
      },
      set (value) {
        this.setInputValue({
          key: 'inpCopyRight',
          value: value
        })
      }
    },
    inpPhoneNumber: {
      get() {
        return this.values.inpPhoneNumber
      },
      set(value) {
        this.setInputValue({
          key: 'inpPhoneNumber',
          value: value
        })
      }
    },
    inpRecommededLinkUrls: {
      get () {
        return this.values.inpRecommededLinkUrls
      },
      set (value) {
        this.setInputValue({
          key: 'inpRecommededLinkUrls',
          value: value
        })
      }
    },
    searchDeviceSerial: {
      get() {
        return this.filters.searchDeviceSerial;
      },
      set(value) {
        this.setInputFilter({
          key: "searchDeviceSerial",
          value: value
        });
      }
    },

    // button
    disableAddLinkButton () {

    },

    // validate
    inpAreaCodeIsValid () {
      return Validator.validText(this.inpAreaCode)
    },
    inpMaxLinkedSPCountIsValid () {
      return this.inpMaxLinkedSPCount > 0
    },
    inpServiceNameIsValid () {
      return Validator.validText(this.inpServiceName)
    },
    inpContactIsValid () {
      return Validator.validText(this.inpContact)
    },
    inpCopyRightIsValid () {
      return Validator.validText(this.inpCopyRight)
    },
    formIsValid () {
      return this.inpAreaCodeIsValid &&
        this.inpMaxLinkedSPCountIsValid &&
        this.inpServiceNameIsValid &&
        this.inpContactIsValid &&
        this.inpCopyRightIsValid
    },
    disableConfirmButton () {
      return !this.formIsValid
    },
    searchDeviceSerialIsValid() {
      return Validator.validText(this.searchDeviceSerial);
    },
    showModelName() {
      return Validator.validText(this.modelName);
    },
    disabledReleaseDevice() {
      return this.linkedSmartPhoneCount > 0;
    }
  },
  watch: {
    inpAreaCode: function (to) {
      if (to) {
        let str = to.replace(/'/g, '')
        str = str.replace(/"/g, '')
        str = str.replace(/</g, '')
        str = str.replace(/>/g, '')
        this.inpAreaCode = Validator.charByteLimit(str, 20)
      }
    },
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      } else if (this.confirmKey === "spRelease") {
        if (to) this.spRelease()
      } else if (this.confirmKey === "deleteLinkCategory") {
        if (to) {
          this.onDeleteLinkCategory()
          this.deleteTargetLinkCategory = null
        }
      }
    },
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      getLinkCategory: 'serviceLinkCategory/getLinkCategory',
      storeLinkCategory: 'serviceLinkCategory/storeLinkCategory',
      updateLinkCategory: 'serviceLinkCategory/updateLinkCategory',
      deleteLinkCategory: 'serviceLinkCategory/deleteLinkCategory',
    }),
    ...mapMutations({
      setInputValue: 'serviceFunctionDetail/setInputValue',
      setInputFilter: 'serviceFunctionDetail/setInputFilter',
    }),

    init () {
      this.loading = false
    },
    turnBack () {
      this.$router.push({
        name: 'ServiceFunction',
        params: {
          serviceId: this.serviceUuid
        }
      })
    },

    postData () {
      this.processing = true

      // jsonb : FunctionFollow(見守り機能)
      let jsonb = {
        areaCode: this.inpAreaCode,
        maxLinkedSPCount: this.inpMaxLinkedSPCount,
        serviceName: this.inpServiceName,
        contact: this.inpContact,
        copyRight: this.inpCopyRight,
      }
      // サービス利用規約設定
      if (this.inpServiceProtocol) {
        jsonb.serviceProtocol = Jsonb.requestFile(this.values.serviceProtocol, this.inpServiceProtocol)
      }
      // ローディングアニメーション設定
      if (this.inpLoadingAnimationFile) {
        jsonb.loadingAnimationFile = Jsonb.requestFile(this.values.loadingAnimationFile, this.inpLoadingAnimationFile)
      }
      // 担当部署名
      if (this.inpDepartmentInCharge) {
        jsonb.departmentInCharge = this.inpDepartmentInCharge
      }
      // 電話番号
      if (this.inpPhoneNumber) {
        jsonb.phoneNumber = this.inpPhoneNumber
      }
      // リンク集カテゴリ
      if (this.linkCategoryList.length) {
        jsonb.linksCategories = this.linkCategoryList.map(item => ({
          uuid: item.linkCategoryUuid,
          name: item.categoryName
        }))
      }
      // おすすめリンク設定
      if (this.$refs.recommendLink && this.$refs.recommendLink.length) {
        const recommededLinkUrls = []
        this.$refs.recommendLink.forEach(item => {
          let obj = {
            name: item.input.name,
            dataSourceType: item.input.dataSourceType
          }
          if (item.input.linkCategory) {
            obj.category = {
              uuid: item.input.linkCategory,
              name:
              this.linkCategoryList.find(
                linkCategory =>
                  linkCategory.linkCategoryUuid === item.input.linkCategory
              ).categoryName
            }
          }
          if (item.input.parameters !== null) {
            obj.parameters = item.input.parameters
          }
          if (item.input.pdfFile) {
            obj.pdfFile = item.input.pdfFile
          }

          // validate
          if (Validator.validText(obj.name) &&
            Validator.validSelect(obj.dataSourceType)) {
            // PDFファイルの場合
            if (obj.dataSourceType === 1 &&
              Validator.validFile(obj.pdfFile))
              recommededLinkUrls.push(obj)
            // アプリ遷移、WEBの場合
            if (obj.dataSourceType !== 1 &&
              Validator.validText(obj.parameters))
              recommededLinkUrls.push(obj)
          }
        })
        if (recommededLinkUrls.length)
          jsonb.recommededLinkUrls = recommededLinkUrls
      }
      // console.log(jsonb.recommededLinkUrls)

      this.uploadVisualFiles(this.inpMainVisualFile)
        .then(res => {
          if (res === 'none') {
            // メインビジュアル画像設定
            if (this.inpMainVisualFile)
              jsonb.mainVisualFile = this.inpMainVisualFile
          } else {
            // メインビジュアル画像設定
            jsonb.mainVisualFile = {
              fileName: res.fileName,
              contentType: res.contentType,
              fileUri: res.fileUri,
              fileSize: res.fileSize,
              thumbnailUri: res.thumbnailUri
            }
          }
          return this.uploadVisualFiles(this.inpSubVisualFile)
        })
        .then(res => {
          if (res === 'none') {
            // メインビジュアル画像設定
            if (this.inpSubVisualFile)
              jsonb.subVisualFile = this.inpSubVisualFile
          } else {
            // サブビジュアル画像設定
            jsonb.subVisualFile = {
              fileName: res.fileName,
              contentType: res.contentType,
              fileUri: res.fileUri,
              fileSize: res.fileSize,
              thumbnailUri: res.thumbnailUri,
            }
          }
          this.postOtherData(jsonb)
        })
        .catch(res => {
          this.processing = false
          this.showError(res)
        })
    },

    postOtherData(jsonb) {
      // リクエストパラメータ
      let parameters = {
        serviceUuid: this.serviceUuid,
        serviceFunctionUuid: this.serviceFunctionUuid,
        request: {
          familyInfoSetting: jsonb
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceFunction'],
        ['v1ServiceFunctionPut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.functionName + '情報の登録',
              body: this.functionName + '情報を登録しました。',
            })

            // 一覧へリダイレクト
            this.turnBack()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    confirmData () {
      // validate
      if (this.formIsValid) {
        // confirm
        this.showConfirm({
          key: 'register',
          title: '',
          body: 'この' + this.functionName + '情報を登録しますか？'
        })
      }
    },

    /**
     * ファイルの変更
     */
    changeFileFromSelector (props) {
      console.log('changeFileFromSelector', props)
      this.setInputValue({
        key: props.name,
        value: Jsonb.formatFile(props.data)
      })
    },
    /**
     * ファイルの削除
     */
    deleteFileFromSelector (props) {
      console.log('deleteFileFromSelector', props)
      this.setInputValue({
        key: props.name,
        value: null
      })
    },

    /**
     * メインビジュアル画像設定
     */
    changeMainVisualFile(param) {
      this.setInputValue({
        key: 'inpMainVisualFile',
        value: param.file
      })
    },
    deleteMainVisualFile() {
      this.setInputValue({
        key: 'inpMainVisualFile',
        value: null
      })
    },
    /**
     * サブビジュアル画像設定
     */
    changeSubVisualFile(param) {
      this.setInputValue({
        key: 'inpSubVisualFile',
        value: param.file
      })
    },
    deleteSubVisualFile() {
      this.setInputValue({
        key: 'inpSubVisualFile',
        value: null
      })
    },
    /**
     * ビジュアル画像アップロード
     */
    uploadVisualFiles(inputFile) {
      return new Promise((resolve, reject) => {
        (async () => {
          if (!inputFile || !(inputFile instanceof File)) return resolve("none")
          const parameter = {
            attachment: await ImageResize.getCompressedImage(inputFile)
          }
          await ApiManager.request(
            ['file'],
            ['v1FileS3Post'],
            [parameter])
            .then(res => {
              let status = Utility.parseResponse(res)
              if (status.result) {
                resolve(res[0].data)
              } else if (status.error) {
                reject(res)
              } else {
                reject(null)
              }
            })
            // eslint-disable-next-line
            .catch(error => {
              reject(null)
            })
        })()
      })
    },
    /**
     * リンク集カテゴリ設定
     */
    initLinkCategoryList() {
      this.getLinkCategory({
        serviceUuid: this.serviceUuid
      })
          .then(res => {
            this.processing = false
          })
          .catch(error => {
            this.processing = false
            this.showError(error || null);
          });
    },
    addLinkCategoryItem() {
      this.linkCategoryList.unshift({
        linkCategoryUuid: null,
        categoryName: null,
      });
    },
    isLinkCategoryCanUpdate(param) {
      const currentItem = this.linkCategoryList.find(current => current.linkCategoryUuid === param)
      const originalItem = this.originalCategoryList.find(original => original.linkCategoryUuid === param)
      return !this.linkCategoryList.length || currentItem.categoryName !== originalItem?.categoryName
    },
    isLinkCategoryCanDelete(param) {
      const currentItem = this.linkCategoryList.find(current => current.linkCategoryUuid === param)
      const originalItem = this.originalCategoryList.find(original => original.linkCategoryUuid === param)
      return this.linkCategoryList.length && currentItem.categoryName === originalItem?.categoryName
    },
    isLinkCategoryUsed(param) {
      if (this.inpRecommededLinkUrls && this.inpRecommededLinkUrls.length) {
        return this.inpRecommededLinkUrls.some(item => item.category === param)
      }
      return false
    },
    onStoreLinkCategory(param) {
      this.processing = true
      if (param.linkCategoryUuid) {
        let serviceLinkCategoryUpdParams = {
          serviceUuid: this.serviceUuid,
          linkCategoryUuid: param.linkCategoryUuid,
          request: {
            categoryName: param.categoryName
          }
        }
        this.updateLinkCategory(serviceLinkCategoryUpdParams)
          .then(res => {
            this.showToast({
              title: this.linkCategoryName + '情報の更新',
              body: this.linkCategoryName + 'を更新しました。'
            })
            this.initLinkCategoryList()
          })
          .catch(error => {
            this.processing = false
            this.showError(error || null)
          })
      } else {
        let serviceLinkCategoryStoreParams = {
          serviceUuid: this.serviceUuid,
          request: {
            categoryName: param.categoryName
          }
        }
        this.storeLinkCategory(serviceLinkCategoryStoreParams)
          .then(res => {
            this.showToast({
              title: this.linkCategoryName + '情報の登録',
              body: this.linkCategoryName + 'を登録しました。'
            })
            this.initLinkCategoryList()
          })
          .catch(error => {
            this.processing = false
            this.showError(error || null)
          })
      }
    },
    deleteLinkCategoryConfirm(param) {
      this.deleteTargetLinkCategory = param.linkCategoryUuid
      this.showConfirm({
        key: "deleteLinkCategory",
        title: "",
        body: this.linkCategoryName + " : " + param.categoryName + "を解除しますか？",
        acceptLabel: "承認"
      });
    },
    onDeleteLinkCategory() {
      this.processing = true
      let serviceLinkCategoryDelParams = {
        serviceUuid: this.serviceUuid,
        linkCategoryUuid: this.deleteTargetLinkCategory
      }
      this.deleteLinkCategory(serviceLinkCategoryDelParams)
        .then(res => {
          this.showToast({
            title: this.linkCategoryName + '情報の削除',
            body: this.linkCategoryName + 'を削除しました。'
          })
          this.initLinkCategoryList()
        })
        .catch(error => {
          this.processing = false
          this.showError(error || null)
        })
    },

    /**
     * おすすめリンク設定の追加
     */
    addLinkItem () {
      let org = $.extend(true, [], this.inpRecommededLinkUrls)
      this.inpRecommededLinkUrls = []
      org.push({
        name: null,
        dataSourceType: ''
      })
      this.inpRecommededLinkUrls = org
    },
    getDeviceData() {
      this.processing = true;
      let parameters = {
        serviceUuid: this.serviceUuid,
        communityUuid: this.communityUuid,
        filters: {
          deviceSerial: this.searchDeviceSerial,
          matchType: 2
        }
      };
      // ApiManager.request(["community"], ["v1LocationNicknameGet"], [parameters])
      ApiManager.request(["community"], ["v1LocationListGet"], [parameters])
          .then(res => {
            this.processing = false;
            let status = Utility.parseResponse(res);

            if (status.result) {
              if (res[0].data.locations.length > 0) {
                this.modelName = res[0].data.locations[0].locationNumber;
                this.linkedSmartPhoneCount = res[0].data.locations[0].linkedSmartPhoneCount;
              } else {
                this.modelName = "";
                this.linkedSmartPhoneCount = 0;
                this.showError([
                  {
                    status: 400,
                    data: {
                      errors: [
                        {
                          code: "E2008",
                          message: "該当するロケーションが存在しません"
                        }
                      ]
                    }
                  }
                ]);
              }
              // 該当するロケーションが存在しません
              // ロケーションID: XXXXXXXXXXに紐づくスマホアプリを一括連携解除しますか?
            } else if (status.error) {
              this.modelName = "";
              this.linkedSmartPhoneCount = 0;
              this.showError(res);
            } else {
              this.modelName = "";
              this.linkedSmartPhoneCount = 0;
              this.showError(null);
            }
          })
          .catch(error => {
            this.processing = false;
          });
    },

    deleteLinkDevice() {
      this.showConfirm({
        key: "spRelease",
        title: "",
        body: "ロケーションID : " + this.modelName + "に紐づくスマホアプリを一括連携解除しますか？",
        acceptLabel: "連携解除"
      });
    },
    spRelease() {
      this.processing = true;

      let parameters = {
        releaseType: 1,
        serviceUuid: this.serviceUuid,
        deviceSerial: this.searchDeviceSerial
      };

      ApiManager.request(
          ["serviceFunction"],
          ["v1ServiceSpRelease"],
          [parameters]
      )
          .then(res => {
            this.processing = false;
            let status = Utility.parseResponse(res);

            if (status.result) {
              this.modelName = "";
              // toast
              this.showToast({
                title: "スマホ連携解除",
                body: "に紐づいた連携スマホアプリを一括解除しました。"
              });
              this.closeModal();
            } else if (status.error) {
              // エラーメッセージ表示
              this.showError(res);
            } else {
              // アプリケーションエラー表示
              this.showError(null);
            }
          })
          .catch(error => {
            this.processing = false;
          })
    }
  }
}
